// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","logo":"Navbar_logo__YJM-Q","hamburger":"Navbar_hamburger__pO2aG","navLinks":"Navbar_navLinks__+SFal"};